import React from 'react';
import { useRef } from 'react';
import TablaFiltering from '../../../components/plugins/TablaFiltering';
// import DataTableFilterDemo from "../../../components/plugins/DataTableFilterDemo";

const ModalContactos = () => {

    const cerrarModalExamenRef = useRef()

    return (
      <div
        className="modal fade bd-example-modal-lg modal-contactos"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-success">
              <h5 className="modal-title text-white" id="exampleModalLabel">
                Contactos
              </h5>
              <button
                type="button"
                ref={cerrarModalExamenRef}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body px-5">
              <TablaFiltering/>
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default ModalContactos;